import config from '@/config';

export const getBrandLogoUrl = ({
  organizationSlug,
  requestId,
}: {
  organizationSlug: string;
  requestId?: string | null;
}): string => {
  if (requestId) {
    return `${config.apiUrl}/requests/${requestId}/logo`;
  }

  return `${config.apiUrl}/organizations/${organizationSlug}/logo`;
};
